export default {
    profile: 'Profile',
    companyProfile: 'Company Profile',
    companyName: 'Company Name',
    hqAddress: 'HQ Address',
    businessDescription: 'Business Description',
    contact: 'Contact',
    fullName: 'Full Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'E-mail',
    phoneNumber: 'Phone Number',
    edit: 'edit',
    cancel: 'cancel',
    save: 'save',
    emailIsRequired: 'E-mail is required',
    emailMustBeValid: 'E-mail format must be valid',
    incorrectPhoneNubmer: 'Incorrect phone nubmer',
    congratulation: 'Congratulation',
    errorMessage: 'Error Message',
    companyProfileIsUpdated: 'Company Profile is updated',
    imageCannotBeNull: 'Image can not be null'
}
